import { TrlRadioButton } from './TrlRadioButton';

export { TrlRadioButton } from './TrlRadioButton';

export default TrlRadioButton;
